import React, { useState, useEffect } from "react";
import { useQuery, useMutation } from "react-query";
import { toast } from "react-toastify";
import api from "../../../utils/api";

export default function DoctorProfile() {
  const [form, setForm] = useState({
    name: "", email: "", phone: "", degree: "", specialization: "",
    bio: "", address: "", city: "", consultationFees: "",
  });

  const { data, isLoading } = useQuery("doctor-profile", () =>
    api.get("/doctor/profile")
  );

  useEffect(() => {
    if (data?.profile) {
      const p = data.profile;
      setForm({
        name: p.name ?? "",
        email: p.email ?? "",
        phone: p.phone ?? "",
        degree: p.degree ?? "",
        specialization: p.specialization ?? "",
        bio: p.bio ?? "",
        address: p.address ?? "",
        city: p.city ?? "",
        consultationFees: p.consultation_fees ?? "",
      });
    }
  }, [data]);

  const updateMutation = useMutation(
    () => api.put("/doctor/profile", form),
    { onSuccess: () => toast.success("Profile updated") }
  );

  const handleChange = (e) =>
    setForm((f) => ({ ...f, [e.target.name]: e.target.value }));

  if (isLoading) return <div className="text-slate-500">Loading…</div>;

  const FIELDS = [
    { name: "name", label: "Full Name" },
    { name: "email", label: "Email", type: "email" },
    { name: "phone", label: "Phone" },
    { name: "degree", label: "Degree / Qualifications" },
    { name: "specialization", label: "Specialization" },
    // { name: "consultationFees", label: "Default Consultation Fees (₹)", type: "number" },
    { name: "address", label: "Home Address" },
    { name: "city", label: "City" },
  ];

  return (
    <div className="max-w-2xl">
      <div className="card">
        <h2 className="font-display font-semibold text-slate-800 text-lg mb-6">
          Doctor Profile
        </h2>
        <div className="grid grid-cols-2 gap-4">
          {FIELDS.map(({ name, label, type = "text" }) => (
            <div key={name} className={name === "address" ? "col-span-2" : ""}>
              <label className="block text-xs font-semibold text-slate-500 mb-1.5 uppercase tracking-wide">
                {label}
              </label>
              <input
                type={type}
                name={name}
                value={form[name]}
                onChange={handleChange}
                className="input-field"
              />
            </div>
          ))}
          <div className="col-span-2">
            <label className="block text-xs font-semibold text-slate-500 mb-1.5 uppercase tracking-wide">
              Bio / About
            </label>
            <textarea
              name="bio"
              value={form.bio}
              onChange={handleChange}
              rows={3}
              className="input-field resize-none"
            />
          </div>
        </div>
        <button
          onClick={() => updateMutation.mutate()}
          disabled={updateMutation.isLoading}
          className="btn-primary mt-5"
        >
          {updateMutation.isLoading ? "Saving…" : "Save Changes"}
        </button>
      </div>
    </div>
  );
}